import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, resolveComponent as _resolveComponent, isRef as _isRef, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createBlock as _createBlock, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-421f2c7d"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "songScreen" }
const _hoisted_2 = { class: "search_div" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "营销位：", -1))
const _hoisted_4 = /*#__PURE__*/_createTextVNode("查找")
const _hoisted_5 = /*#__PURE__*/_createTextVNode("新增")
const _hoisted_6 = ["src"]
const _hoisted_7 = ["src"]
const _hoisted_8 = /*#__PURE__*/_createTextVNode("编辑")
const _hoisted_9 = /*#__PURE__*/_createTextVNode("删除")
const _hoisted_10 = /*#__PURE__*/_createTextVNode("电视屏公播营销位")
const _hoisted_11 = /*#__PURE__*/_createTextVNode("电视屏暂停营销位")
const _hoisted_12 = /*#__PURE__*/_createTextVNode("评分结束营销位")
const _hoisted_13 = /*#__PURE__*/_createTextVNode("触摸屏屏保营销位")
const _hoisted_14 = { class: "flex_div" }
const _hoisted_15 = { class: "flex1" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "bff" }, "秒", -1))
const _hoisted_17 = /*#__PURE__*/_createTextVNode("启用")
const _hoisted_18 = /*#__PURE__*/_createTextVNode("停用")
const _hoisted_19 = {
  key: 0,
  class: "sc_div"
}
const _hoisted_20 = ["src"]
const _hoisted_21 = ["src"]
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createTextVNode("支持jpg、png图片，大小2M以内"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("支持MP4视频，大小10M以内"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("分辨率1920*1080 px")
], -1))
const _hoisted_23 = { class: "flex1" }
const _hoisted_24 = {
  key: 0,
  class: "img_div"
}
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "img_dia",
  src: "https://wximg.ycvod.cn/yinchuang/yunGuan/tvPlay.png"
}, null, -1))
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "在播放一定数量公播歌曲时，插入该营销素材", -1))
const _hoisted_27 = [
  _hoisted_25,
  _hoisted_26
]
const _hoisted_28 = {
  key: 1,
  class: "img_div"
}
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "img_dia",
  src: "https://wximg.ycvod.cn/yinchuang/yunGuan/tvStop.png"
}, null, -1))
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "歌曲暂停时，电视屏上显示该营销位", -1))
const _hoisted_31 = [
  _hoisted_29,
  _hoisted_30
]
const _hoisted_32 = {
  key: 2,
  class: "img_div"
}
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "img_dia",
  src: "https://wximg.ycvod.cn/yinchuang/yunGuan/evaluateEnd.png"
}, null, -1))
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "评分歌曲演唱结束时，显示该营销素材", -1))
const _hoisted_35 = [
  _hoisted_33,
  _hoisted_34
]
const _hoisted_36 = {
  key: 3,
  class: "img_div"
}
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "img_dia",
  src: "https://wximg.ycvod.cn/yinchuang/yunGuan/publicScr.png"
}, null, -1))
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "触摸屏一段时长内未操作，即显示该营销位", -1))
const _hoisted_39 = [
  _hoisted_37,
  _hoisted_38
]
const _hoisted_40 = {
  slot: "footer",
  class: "dialog-footer"
}
const _hoisted_41 = /*#__PURE__*/_createTextVNode("确 定")
const _hoisted_42 = /*#__PURE__*/_createTextVNode("取 消")

import { ref, getCurrentInstance,onMounted } from 'vue'
  import pageTitle from '@/components/pageTitle.vue';
  import { ElMessage,ElMessageBox } from 'element-plus';
  import { Plus, CircleClose } from '@element-plus/icons-vue'
  import { addAdsense,getAdsenseList,editAdsense,delAdsense } from '@/axios/smartMarket';
  type fos = {
    id: number,
    ad_space_id: number,
    duration?: number|string,
    sort: number,
    is_enable: number,
    // volume: 30,
    validity_end_time?: string,
    validity_start_time?:string
  }
  
export default /*#__PURE__*/_defineComponent({
  __name: 'songScreen',
  setup(__props) {

  let marks = ref('')
  let screenDialog = ref(false)
  let zxURL = ref('');
  let zxType = ref(1)
  let tableData = ref([]);
  let form = ref<fos>({
    id: 0,
    ad_space_id: 1,
    sort: 1,
    is_enable: 1,
  })
  let { proxy } = getCurrentInstance() as any;

  onMounted(()=> {
    getAdListByPremiseIDs();
  })

  function getAdListByPremiseIDs(){
    let comps = JSON.parse(sessionStorage.getItem('accountInfo') || '').company_list
    getAdsenseList({
      premise_id: comps[sessionStorage.getItem('checkCompany') || 0].premises_id,
      ad_space_id: marks.value
    }).then((data:any)=> {
      tableData.value = data;
    }).catch((err:any)=>{})
  }

  //打开弹窗
  function showScreen(values?:any){
    screenDialog.value = true;
    if(values){
      let val = JSON.parse(JSON.stringify(values));
      form.value = val;
      form.value.validity_end_time = toDate(val.validity_end_time*1000,2);
      form.value.validity_start_time = toDate(val.validity_start_time*1000,2);
      zxURL.value = val.url;
      zxType.value = val.type;
    }
  }
  function toDate(val:string|number,type:number){
    if(!val) return '';
    let dates = new Date(val);
    let tens = (num:number) => {
      if(num>9) return num;
      return '0'+num
    }
    let infos = dates.getFullYear() + '-' + tens(dates.getMonth()+1) + '-' + tens(dates.getDate());
    if(type == 1){
      infos = infos + ' ' + tens(dates.getHours()) + ':' + tens(dates.getMinutes()) + ':' + tens(dates.getSeconds()) 
    }
    return infos
  }
  //关闭弹窗
  function closeDia(){
    screenDialog.value = false;
    form.value = {
      id: 0,
      ad_space_id: 1,
      duration: '',
      sort: 1,
      is_enable: 1,
      // volume: 30,
      validity_end_time: '',
      validity_start_time: ''
    }
    zxURL.value = '';
    zxType.value = 1
  }
  //图片删除
  function delImg(){
    zxURL.value = '';
  }
  //图片上传
  function beforeAvatarUpload(val:any){
    console.log(val)
    if(val.type.includes('jpg') || val.type.includes('jpeg') || val.type.includes('png') || val.type.includes('mp4')){
      let formdata = new FormData();
      formdata.append('file',val);
      formdata.append('project','om');
      formdata.append('modular','peelerCurrency');
      formdata.append('file_type','image');
      let urls = `${proxy?.$uploadUrl}/yc_upload/upload/uploads`;
      let xml = new window.XMLHttpRequest();
      xml.open('post',urls,true)
      xml.send(formdata);
      xml.onreadystatechange = function() {
        if(xml.readyState==4 && xml.status==200){
          let infos = JSON.parse(xml.response);
          console.log(infos)
          zxType.value = val.type.includes('image') ? 1 : 2
          zxURL.value = infos.data.url;
        }
      }
      return false;
    }
    else{
      ElMessage('请选择推荐格式文件')
    }
    return false;
  }
  //弹窗按钮点点
  function queryClick(){
    let info:any = form.value
    info.url = zxURL.value
    info.type = zxType.value
    if(!info.duration){
      ElMessage('请输入播放时长');
      return false;
    }
    if(!info.validity_start_time){
      ElMessage('请选择开始时间');
      return false;
    }
    if(!info.validity_end_time){
      ElMessage('请选择结束时间');
      return false;
    }
    if(!zxURL.value){
      ElMessage('请上传素材');
      return false;
    }
    if(!info.id){
      let comps = JSON.parse(sessionStorage.getItem('accountInfo') || '').company_list
      info.premise_id = comps[sessionStorage.getItem('checkCompany') || 0].premises_id;
      info.scene = comps[sessionStorage.getItem('checkCompany') || 0].scene;
      info.volume = 100;
      delete info.id;
      console.log(info);
      addAdsense(info).then((data:any) => {
        ElMessage('新增成功')
        closeDia();
        getAdListByPremiseIDs();
      }).catch(err => {
        console.log(err)
      })
    }
    else{
      editAdsense(info).then((data:any) => {
        ElMessage('修改成功')
        getAdListByPremiseIDs();
        closeDia();
      }).catch((err:any) => {
        console.log(err)
      })
    }
  }
  //删除
  function delScreen(id:number,prid:number){
    ElMessageBox.confirm('是否删除该条营销位素材').then(() => {
      delAdsense({
        id: id,
        premise_id: prid
      }).then((data:any) => {
        ElMessage('删除成功')
        getAdListByPremiseIDs();
      }).catch((err:any) => {
        console.log(err)
      })
    }).catch(() => {
      
    })
  }

return (_ctx: any,_cache: any) => {
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_radio = _resolveComponent("el-radio")!
  const _component_el_radio_group = _resolveComponent("el-radio-group")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_input_number = _resolveComponent("el-input-number")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_upload = _resolveComponent("el-upload")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(pageTitle, { title: "K歌屏营销位管理" }),
      _createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        _createVNode(_component_el_select, {
          modelValue: _unref(marks),
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(marks) ? (marks).value = $event : marks = $event)),
          clearable: "",
          placeholder: "请选择营销位"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_option, {
              value: "1",
              label: "电视屏公播营销位"
            }),
            _createVNode(_component_el_option, {
              value: "2",
              label: "电视屏暂停营销位"
            }),
            _createVNode(_component_el_option, {
              value: "3",
              label: "评分结束营销位"
            }),
            _createVNode(_component_el_option, {
              value: "4",
              label: "触摸屏屏保营销位"
            })
          ]),
          _: 1
        }, 8, ["modelValue"]),
        _createVNode(_component_el_button, {
          type: "primary",
          onClick: getAdListByPremiseIDs
        }, {
          default: _withCtx(() => [
            _hoisted_4
          ]),
          _: 1
        }),
        _createVNode(_component_el_button, {
          type: "primary",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (showScreen()))
        }, {
          default: _withCtx(() => [
            _hoisted_5
          ]),
          _: 1
        })
      ]),
      _createVNode(_component_el_table, {
        data: _unref(tableData),
        border: "",
        style: {"width":"100%"},
        fit: ""
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_table_column, {
            prop: "sort",
            label: "排序",
            width: "80px"
          }),
          _createVNode(_component_el_table_column, {
            label: "素材",
            width: "270px"
          }, {
            default: _withCtx((scope) => [
              (scope.row.type == 1)
                ? (_openBlock(), _createElementBlock("img", {
                    key: 0,
                    class: "sc_info",
                    src: scope.row.url
                  }, null, 8, _hoisted_6))
                : (_openBlock(), _createElementBlock("video", {
                    key: 1,
                    class: "sc_info",
                    src: scope.row.url,
                    controls: ""
                  }, null, 8, _hoisted_7))
            ]),
            _: 1
          }),
          _createVNode(_component_el_table_column, {
            label: "营销位",
            width: "160px"
          }, {
            default: _withCtx((scope) => [
              _createTextVNode(_toDisplayString(scope.row.ad_space_id==1?'电视屏公播营销位':'') + _toDisplayString(scope.row.ad_space_id==2?'电视屏暂停营销位':'') + _toDisplayString(scope.row.ad_space_id==3?'评分结束营销位':'') + _toDisplayString(scope.row.ad_space_id==4?'触摸屏屏保营销位':''), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_el_table_column, {
            prop: "duration",
            label: "播放时长（秒）",
            width: "150px"
          }),
          _createVNode(_component_el_table_column, {
            label: "状态",
            width: "80px"
          }, {
            default: _withCtx((scope) => [
              _createTextVNode(_toDisplayString(scope.row.is_enable==0?'停用':'启用'), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_el_table_column, {
            label: "开始时间",
            width: "120px"
          }, {
            default: _withCtx((scope) => [
              _createElementVNode("span", null, _toDisplayString(toDate(scope.row.validity_start_time*1000,2)), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_el_table_column, {
            label: "结束时间",
            width: "120px"
          }, {
            default: _withCtx((scope) => [
              _createElementVNode("span", null, _toDisplayString(toDate(scope.row.validity_end_time*1000,2)), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_el_table_column, { label: "最后修改时间" }, {
            default: _withCtx((scope) => [
              _createElementVNode("span", null, _toDisplayString(toDate(scope.row.updated_at,1)), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_el_table_column, {
            label: "操作",
            fixed: "right",
            width: "160px"
          }, {
            default: _withCtx((scope) => [
              _createVNode(_component_el_button, {
                text: "",
                type: "primary",
                onClick: ($event: any) => (showScreen(scope.row))
              }, {
                default: _withCtx(() => [
                  _hoisted_8
                ]),
                _: 2
              }, 1032, ["onClick"]),
              _createVNode(_component_el_button, {
                text: "",
                type: "primary",
                onClick: ($event: any) => (delScreen(scope.row.id,scope.row.premise_id))
              }, {
                default: _withCtx(() => [
                  _hoisted_9
                ]),
                _: 2
              }, 1032, ["onClick"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["data"])
    ]),
    _createVNode(_component_el_dialog, {
      title: _unref(form).id?'编辑营销位':'新增营销位',
      modelValue: _unref(screenDialog),
      "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (_isRef(screenDialog) ? (screenDialog).value = $event : screenDialog = $event)),
      onClose: closeDia
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_form, {
          model: _unref(form),
          "label-position": "left",
          "label-width": "100px"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form_item, { label: "宣传位" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_radio_group, {
                  modelValue: _unref(form).ad_space_id,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(form).ad_space_id) = $event))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_radio, { label: 1 }, {
                      default: _withCtx(() => [
                        _hoisted_10
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_radio, { label: 2 }, {
                      default: _withCtx(() => [
                        _hoisted_11
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_radio, { label: 3 }, {
                      default: _withCtx(() => [
                        _hoisted_12
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_radio, { label: 4 }, {
                      default: _withCtx(() => [
                        _hoisted_13
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createElementVNode("div", _hoisted_14, [
              _createElementVNode("div", _hoisted_15, [
                _createVNode(_component_el_form_item, { label: "播放时长" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input_number, {
                      modelValue: _unref(form).duration,
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_unref(form).duration) = $event)),
                      placeholder: "建议15s左右",
                      max: 15
                    }, null, 8, ["modelValue"]),
                    _hoisted_16
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, { label: "排序" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input_number, {
                      modelValue: _unref(form).sort,
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_unref(form).sort) = $event)),
                      min: 1,
                      placeholder: "数字越大显示越靠前"
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, { label: "开始时间" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_date_picker, {
                      modelValue: _unref(form).validity_start_time,
                      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_unref(form).validity_start_time) = $event)),
                      "value-format": "YYYY-MM-DD",
                      type: "date",
                      placeholder: "请选择开始时间"
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, { label: "结束时间" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_date_picker, {
                      modelValue: _unref(form).validity_end_time,
                      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_unref(form).validity_end_time) = $event)),
                      "value-format": "YYYY-MM-DD",
                      type: "date",
                      placeholder: "请选择结束时间"
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, { label: "状态" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_radio_group, {
                      modelValue: _unref(form).is_enable,
                      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_unref(form).is_enable) = $event))
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_radio, { label: 1 }, {
                          default: _withCtx(() => [
                            _hoisted_17
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_radio, { label: 0 }, {
                          default: _withCtx(() => [
                            _hoisted_18
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, { label: "上传素材" }, {
                  default: _withCtx(() => [
                    (_unref(zxURL))
                      ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                          _createVNode(_component_el_icon, {
                            class: "el-icon-circle-close",
                            onClick: delImg
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_unref(CircleClose))
                            ]),
                            _: 1
                          }),
                          (_unref(zxType)==1)
                            ? (_openBlock(), _createElementBlock("img", {
                                key: 0,
                                src: _unref(zxURL),
                                class: "upImg"
                              }, null, 8, _hoisted_20))
                            : (_openBlock(), _createElementBlock("video", {
                                key: 1,
                                src: _unref(zxURL),
                                class: "upImg"
                              }, null, 8, _hoisted_21))
                        ]))
                      : (_openBlock(), _createBlock(_component_el_upload, {
                          key: 1,
                          "show-file-list": false,
                          class: "avatar-uploader",
                          action: "",
                          "before-upload": beforeAvatarUpload
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_icon, { class: "el-icon-plus avatar-uploader-icon" }, {
                              default: _withCtx(() => [
                                _createVNode(_unref(Plus))
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })),
                    _hoisted_22
                  ]),
                  _: 1
                })
              ]),
              _createElementVNode("div", _hoisted_23, [
                (_unref(form).ad_space_id==1)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_24, _hoisted_27))
                  : _createCommentVNode("", true),
                (_unref(form).ad_space_id==2)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_28, _hoisted_31))
                  : _createCommentVNode("", true),
                (_unref(form).ad_space_id==3)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_32, _hoisted_35))
                  : _createCommentVNode("", true),
                (_unref(form).ad_space_id==4)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_36, _hoisted_39))
                  : _createCommentVNode("", true)
              ])
            ]),
            _createElementVNode("div", _hoisted_40, [
              _createVNode(_component_el_button, {
                type: "primary",
                onClick: queryClick
              }, {
                default: _withCtx(() => [
                  _hoisted_41
                ]),
                _: 1
              }),
              _createVNode(_component_el_button, { onClick: closeDia }, {
                default: _withCtx(() => [
                  _hoisted_42
                ]),
                _: 1
              })
            ])
          ]),
          _: 1
        }, 8, ["model"])
      ]),
      _: 1
    }, 8, ["title", "modelValue"])
  ], 64))
}
}

})